<div class="shared-grid-actions-wrapper">

    <!-- Week Selector -->
    @if(selectWeekOption) {
    <div class="select-week-wrapper">
        <mat-form-field appearance="outline" class="full-width">
        <mat-select (selectionChange)="selectWeek($event)" placeholder="Select Week" [ngModel]="weekNumber" [disabled]="disableWeekSelector">
            <mat-option *ngFor="let r of dateOptions" [value]="r.reportingWeekID">
            {{r.text}}
            </mat-option>
        </mat-select>
        </mat-form-field>
    </div>
    }
    <!-- Date Range Selector -->
    @if(selectDateRangeOption && !lockStartDate) {
    <div class="select-week-wrapper">
        <mat-form-field appearance="outline" class="full-width">
            <mat-label>Select Date Range</mat-label>
            <mat-date-range-input [rangePicker]="picker">
                <input matStartDate placeholder="Start date" [(ngModel)]="startDateRange" [disabled]="lockStartDate" (dateChange)="selectDateRange()">
                <input matEndDate placeholder="End date" [(ngModel)]="endDateRange" (dateChange)="selectDateRange()">
            </mat-date-range-input>
            <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
            <mat-date-range-picker #picker></mat-date-range-picker>
        </mat-form-field>
    </div>
    }
    
    @if(selectDateRangeOption && lockStartDate) {
    <div class="select-week-wrapper">
        <mat-form-field appearance="outline" class="full-width">
            <mat-label>Choose an End Date</mat-label>
            <input matInput [matDatepicker]="pickerEndDate" placeholder="End date" [(ngModel)]="endDateRange" (dateChange)="selectDateRange()">
            <!-- <input matInput [matDatepicker]="picker"> -->
            <mat-datepicker-toggle matIconSuffix [for]="pickerEndDate"></mat-datepicker-toggle>
            <mat-datepicker #pickerEndDate></mat-datepicker>
        </mat-form-field>
    </div>
    }

    <!-- Foreman Selector -->
    @if(showCrewSelector) {
    <div class="select-week-wrapper">
        <mat-form-field appearance="outline">
            <mat-select (selectionChange)="onSelectForeman($event)" placeholder="Select Crew" [(ngModel)]="employeeID">
                <mat-option *ngFor="let foreman of foreManList" [value]="foreman.employeeID">
                    {{ foreman.firstName }} {{ foreman.lastName }}
                </mat-option>
                <mat-option [value]="0">ALL</mat-option>
            </mat-select>
        </mat-form-field>
    </div>
    }

    <!-- Search Box -->
    @if(showSearchInput) {
    <div class="searchbox-wrapper">
        @if(showHistoryButton) {
            <button class="history-button" mat-icon-button (click)="openJobEditHistoryDialog()">
                <i class="material-icons">history</i>
            </button>
        }
        <mat-form-field appearance="outline" class="searchbox-field">
            <mat-label>Search all fields</mat-label>
            <input
            #searchbox
            matInput
            type="text"
            class="searchboxInput"
            autocomplete="off"
            name="searchbox"
            (keyup.enter)="applySearch()"
            />
        </mat-form-field>
        @if(showSearchButton) {
        <button mat-raised-button color="primary" class="searchbox-button" (click)="applySearch()">
            Search
        </button>
        }
    </div>
    }

    <!-- Multiple Search Selector -->
    @if(showMultipleSearch) {
    <div class="searchBy-wrapper">
        @if(!showInputSearch) {
        <mat-form-field appearance="outline" class="template-select-wrapper">
            <mat-select placeholder="Multiple search" [value]="searchByOption" (selectionChange)="onSearchByChange($event)">
                <mat-option value="pMNumber">Search by PM</mat-option>
                <mat-option value="notificationNumber">Search by Notification #</mat-option>
                <mat-option value="jobAddress">Search by Addresses</mat-option>
                <mat-option value="invoiceNumber">Search by Invoice #</mat-option>
            </mat-select>
        </mat-form-field>
        }
        @if(showInputSearch) {
        <div class="searchBy-wrapper" (click)="onSearchByClick()">
            <span class="multiple-search-category">Search by: {{searchByOption}}</span>
            <span class="multiple-search-input" >{{searchObj?.input}}</span>
        </div>
        }
    </div>
    }

    <!-- Multiple Search by PM -->
    @if(searchByPMs) {
        <div class="searchBy-wrapper">
            @if(!showInputSearch) {
                <button mat-raised-button class="wb-expanded-search-button" color="primary" alt="Expanded Search" (click)="onSearchByPMs()">
                    PM# Search
                </button>
            }
            @if(showInputSearch) {
            <div class="searchBy-wrapper" (click)="onSearchByPMs()">
                <span class="multiple-search-category">Search by: PM#</span>
                <span class="multiple-search-input" >{{searchObj?.input}}</span>
            </div>
            }
        </div>
    }
    
    <!-- Expanded WB Search -->
    @if(showWBExpandedSearch) {
    <div class="searchBy-wrapper">
        @if(!clearExpandedSearchBtn) {
        <button mat-raised-button class="wb-expanded-search-button" color="primary" alt="Expanded Search" (click)="openWBExpandedSearchDialog()">
            Expanded Search
        </button>
        }
        @if(clearExpandedSearchBtn) {
        <div class="expanded-search-wrapper">
            <div class="expanded-search-legend">
                <span class="multiple-search-category">Search by {{expandedSearchObj?.searchBy}}: </span>
                <span class="multiple-search-input" >{{expandedSearchObj?.searchInput}}</span>
                <span class="multiple-search-input" ><b>Date Range:</b> <br/> {{expandedSearchObj?.startDate | date: 'shortDate'}} - {{expandedSearchObj?.endDate | date: 'shortDate'}}</span>
            </div>
            <button mat-icon-button class="wb-expanded-search-button" color="primary" alt="Expanded Search" (click)="clearExpandedSearch()">
                <i class="material-icons">cancel</i>
            </button>
        </div>
        }
    </div>
    }

    <!-- Clear Filters Button -->
    @if(clearFilter) {
    <button mat-button class="clear-filters-button" color="primary" alt="Clear Filters" (click)="onClearFiltersClick()">
        <i class="material-icons">cancel</i>
        <span>Clear <br/> Filters</span>
    </button>
    }

    <!-- Template Selector -->
    @if(showTemplateSelector) {
    <div class="template-wrapper">
        @if (manageViewsEnabled) {
        <!-- Manage Views (MANAGE_VIEWS flag ON) -->
        <mat-icon>calendar_view_week</mat-icon>
        <span class="template-title">Grid <br/>Views</span>
        @if (loadingTemplates) {
        <div class="loading-templates">
            <mat-spinner diameter="12"></mat-spinner>
            <span>Loading views…</span>
        </div>
        } @else {
        <mat-form-field appearance="outline" class="template-select-wrapper">
            <mat-select [value]="activeTemplateViewID" (selectionChange)="onTemplateChange($event)">
              <!-- Trigger shows the selected view's name, or NOTHING when no view
                   is active — "Clear View" acts like a command, not a selection -->
              <mat-select-trigger>{{ activeTemplateName }}</mat-select-trigger>
              <mat-option [value]="0" class="template-clear-option">— clear view —</mat-option>
              @if (globalTemplates.length > 0) {
                <mat-option disabled class="template-group-header">GLOBAL</mat-option>
              }
              @for (template of globalTemplates; track template.templateViewID) {
                <mat-option class="template-view-option" [value]="template.templateViewID">
                {{ template.templateViewName }}
                </mat-option>
              }
              @if (myViewTemplates.length > 0) {
                <mat-option disabled class="template-group-header">MY VIEWS</mat-option>
              }
              @for (template of myViewTemplates; track template.templateViewID) {
                <mat-option class="template-view-option" [value]="template.templateViewID">
                {{ template.templateViewName }}
                </mat-option>
              }
              @if (sharedViewTemplates.length > 0) {
                <mat-option disabled class="template-group-header">SHARED</mat-option>
              }
              @for (template of sharedViewTemplates; track template.templateViewID) {
                <mat-option class="template-view-option" [value]="template.templateViewID">
                {{ template.templateViewName }}
                </mat-option>
              }
            </mat-select>
        </mat-form-field>
        <button mat-icon-button matTooltip="Manage Views" matTooltipPosition="above" color="primary" alt="Manage Views" [disabled]="!gridApi" (click)="openManageViews()">
            <i class="material-icons">edit</i>
        </button>
        @if (activeTemplateViewID !== 0) {
        <button mat-icon-button matTooltip="Reset Grid" matTooltipPosition="above" color="primary" alt="Reset Grid" (click)="resetGridState()">
            <i class="material-icons">restart_alt</i>
        </button>
        }
        }
        } @else {
        <!-- Legacy template selector (flag OFF) -->
        <mat-icon>calendar_view_week</mat-icon>
        <span class="template-title">Grid <br/>Template</span>
        <div class="loading-templates" *ngIf="loadingTemplates">
            <mat-spinner diameter="12"></mat-spinner>
            <span>Loading templates…</span>
        </div>
        @if(templates.length === 0 && !loadingTemplates) {
        <div class="loading-templates">
            <span class="no-templates">No templates available for this grid. <br/>
            Click the <i (click)="openTemplateDialog(0)" class="material-icons add_inLegend">add_circle_outline</i> button to create a new template.</span>
        </div>
        }
        @if(templates.length > 0 && !loadingTemplates) {
        <mat-form-field appearance="outline"  class="template-select-wrapper">
            <mat-select [value]="activeTemplateViewID" (selectionChange)="onTemplateChange($event)">
              @for(template of sharedTemplates; track template.templateViewID) {
                <mat-option [value]="template.templateViewID">
                {{ template.templateViewName }}
                </mat-option>
              }
              @if(sharedTemplates.length > 0 && privateTemplates.length > 0) {
                <mat-option disabled class="template-separator">──────────────</mat-option>
              }
              @for(template of privateTemplates; track template.templateViewID) {
                <mat-option [value]="template.templateViewID">
                {{ template.templateViewName }}
                </mat-option>
              }
            </mat-select>
        </mat-form-field>
        }
        <!-- <button *ngIf="showEditTemplateButton && activeTemplateViewID !== 0" mat-icon-button matTooltip="Edit Template" matTooltipPosition="above" color="primary" alt="Edit Template" (click)="openTemplateDialog()">
            <i class="material-icons">edit</i>
        </button> -->
        @if(sysadmin) {
        <button mat-icon-button matTooltip="Add New Template" matTooltipPosition="above" color="primary" alt="Add new Template" (click)="openTemplateDialog(0)">
            <i class="material-icons">add_circle_outline</i>
        </button>
        }
        @if(activeTemplateViewID !== 0) {
        <button mat-icon-button matTooltip="Edit / Delete Template" matTooltipPosition="above" color="primary" alt="Save Template Changes" (click)="saveTemplateChanges()">
            <i class="material-icons">save_as</i>
        </button>
        }
        @if(activeTemplateViewID !== 0) {
        <button mat-icon-button matTooltip="Reset Grid" matTooltipPosition="above" color="primary" alt="Reset Grid" (click)="resetGridState()">
            <i class="material-icons">restart_alt</i>
        </button>
        }
        }
    </div>
    }
  </div>
